import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfig } from './app-config';
import { UploadReportVersionPayload, GetSignedUploadURLPayload, UploadMasterFileReportVersionPayload } from '../models';
import { ObjectResponse } from '../interfaces';
import { SignedUrlInfo } from '../models/response';

@Injectable()
export class TpSafeService {

  constructor(private http: HttpClient, private _config: AppConfig) { }

  public getSignedUploadURL(payload: GetSignedUploadURLPayload): Observable<any> {
    return this.http.post(this.getTPSafeUploadUrl(), payload);
  }

  public saveFileToTPSafe(signedUrl: string, fileBinary: any): Observable<any> {
    return this.http.put(signedUrl, fileBinary, { headers: { 'Content-Type': fileBinary.type } });
  }

  public saveUploadedReportToTpSafe(signedUrl: string, file: File): Observable<any> {
    return this.http.put(signedUrl, file, { headers: { 'Content-Type': file.type } });
  }

  public getSignedUrlForUploadedReport(payload: UploadReportVersionPayload): Observable<any> {
    return this.http.post(this.getTPSafeUploadReportVersionUrl(), payload);
  }

  public getSignedUrlForUploadingMasterFileReportVersion(payload: UploadMasterFileReportVersionPayload): Observable<ObjectResponse<SignedUrlInfo>> {
    return this.http.post<ObjectResponse<SignedUrlInfo>>(this.getTPSafeUploadMasterFileReportVersionUrl(), payload);
  }

  public deleteLocalFileReport(localFIleReportId: number): Observable<any> {
    return this.http.delete(this.getTPSafeDeleteUrl(localFIleReportId));
  }

  public getSignedDownloadURL(filePath: string, name: string, containerId: number): Observable<any> {
    const payload = {
      filePath,
      name,
      containerId
    };
    return this.http.post(this.getTPSafeDownloadUrl(), payload);
  }

  public downloadFileFromTPSafe(signedUrl: string): Observable<any> {
    return this.http.get(signedUrl);
  }

  protected getTPSafeDownloadUrl(): string {
    return `${this.getApiUrl()}download`;
  }

  protected getTPSafeUploadUrl(): string {
    return `${this.getApiUrl()}upload`;
  }

  protected getTPSafeUploadReportVersionUrl(): string {
    return `${this.getApiUrl()}internal-localfile-report-instance/upload`;
  }

  protected getTPSafeUploadMasterFileReportVersionUrl(): string {
    return `${this.getApiUrl()}master-file-report-version/upload`;
  }

  protected getTPSafeDeleteUrl(localFIleReportId): string {
    return `${this.getApiUrl()}delete/${localFIleReportId}`;
  }

  private getApiUrl(): string {
    return `${this._config.getTpSafeApiUrl()}/v1/`;
  }
}
